import { formatDate } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { CarouselComponent } from 'ngx-bootstrap/carousel';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { Prescriber } from 'src/app/shared/models/services-aide-emploi/prescriber';
import {
	Slot,
	WeekSlots
} from 'src/app/shared/models/services-aide-emploi/slot';
import { DateUtils } from 'src/app/shared/utils/date-utils';

@Component({
	selector: 'app-prescriber-booking',
	templateUrl: './prescriber-booking.component.html',
	styleUrls: ['./prescriber-booking.component.scss']
})
export class PrescriberBookingComponent implements OnInit {
	prescriber: Prescriber = new Prescriber();
	selectedSlotIndex: number = -1;
	selectedSlot: Slot | null = null;
	weekDays = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi'];
	slots: Slot[] = [];
	slotsByDay: { day: string; date: string; slots: Slot[] }[] = [];
	currentTime = new Date();

	weeks: WeekSlots[][] = [];
	currentDate: Date;

	appointmentConfirmed: boolean = false;
	confirmedAppointment: Slot | null = null;
	errorMessage: string | null = null;

	constructor(
		private facade: FacadeService,
		private dateUtils: DateUtils,
		private logger: LogService
	) {}

	ngOnInit(): void {
		this.currentDate = this.dateUtils.getMonday(new Date());
		this.loadSlotsForWeek(this.currentDate);
		this.loadRegisteredPrescriber();
		this.loadBookedAppointment();
	}

	loadSlotsForWeek(date: Date): void {
		let year = date.getFullYear();
		let weekNumber = this.dateUtils.getWeekNumber(date);

		this.facade.availabilityService
			.getPrescriptionAvailability(year, weekNumber)
			.subscribe((slots: Slot[]) => {
				const weekData = this.weekDays.map((day, index) => {
					const currentDate = new Date(date);
					currentDate.setDate(currentDate.getDate() + index);
					const dateFormatted = formatDate(currentDate, 'dd/MM', 'fr-FR');
					let daySlots = slots.filter((slot) => {
						if (slot.weekDay === index + 1) {
							let slotDate = new Date(currentDate);
							let slotTimeInMinutes = slot.startTime;
							let currentTimeInMinutes =
								this.currentTime.getHours() * 60 +
								this.currentTime.getMinutes();
							let isToday =
								slotDate.getDate() === this.currentTime.getDate() &&
								slotDate.getMonth() === this.currentTime.getMonth() &&
								slotDate.getFullYear() === this.currentTime.getFullYear();

							return (
								!(isToday && slotTimeInMinutes < currentTimeInMinutes) &&
								!(slotDate < this.currentTime)
							);
						}
						return false;
					});

					return {
						day: day,
						date: dateFormatted,
						slots: daySlots
					};
				});
				this.weeks.push(weekData);
			});
	}

	loadRegisteredPrescriber() {
		this.facade.prescriberService.getAuthenticatedPrescriber().subscribe({
			next: (v) => (this.prescriber = v),
			error: (e) => {}
		});
	}

	loadBookedAppointment() {
		this.facade.prescriberService.getBookedAppointment().subscribe({
			next: (appointment) => {
				this.confirmedAppointment = appointment;
				this.appointmentConfirmed = true;
				this.errorMessage = null;
			},
			error: (e) => {}
		});
	}

	addWeek() {
		this.currentDate = this.dateUtils.addDays(this.currentDate, 7);
		this.loadSlotsForWeek(this.currentDate);
	}

	getWeekNumber(weekIndex) {
		return this.dateUtils.getWeekNumber(new Date()) + weekIndex;
	}

	formatTime(minutes: number): string {
		const hours = Math.floor(minutes / 60);
		const mins = minutes % 60;
		return `${hours}:${mins.toString().padStart(2, '0')}`;
	}

	onSlotSelected(slot: Slot, dateString: string) {
		this.selectedSlot = slot;
		// Assurez-vous que dateString est déjà au format dd/MM
		const [day, month] = dateString.split('/').map(Number);
		const year = new Date().getFullYear(); // Attention à la gestion de fin d'année
		const correctDate = new Date(year, month - 1, day);

		this.selectedSlot.date = correctDate;
	}

	submitForm() {
		if (this.selectedSlot) {
			this.selectedSlot.prescriber = this.prescriber;
			this.logger.info('Rendez-vous booked:', this.selectedSlot);
			this.facade.prescriberService
				.bookAppointment(this.selectedSlot)
				.subscribe({
					next: (appointment) => {
						this.confirmedAppointment = appointment;
						this.appointmentConfirmed = true;
						this.errorMessage = null;
					},
					error: (error) => {
						this.errorMessage =
							"Le rendez-vous n'a pas pu être validé. Veuillez réessayer.";
						this.logger.info('Error booking appointment:', error);
					}
				});
		}
	}
}
